/**
 * Groups field definitions by their entity label/type for display in pickers.
 */
export const groupFieldsByEntity = (fields) =>
  fields.reduce((acc, field) => {
    const group = field.entityLabel || field.entityType || 'Other';
    if (!acc[group]) acc[group] = [];
    acc[group].push(field);
    return acc;
  }, {});
